import ServicesContainer from './ServicesContainer';

export default ServicesContainer;



// WEBPACK FOOTER //
// ./src/components/pages/ServicesPage/index.js